import { SUPER_ADMIN_ROLE } from '@/types';

export const SAMPLES_ALLOWED_ROLES = [SUPER_ADMIN_ROLE] as const;
